module.exports = __webpack_public_path__ + "img/category-skill-game-hover.8c7a52d4.png";